export const GET_EVENTS = "GET_EVENTS"
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS"
// A list read again in the background while its texts translate (ADR 0013): the events, or an event's announcements.
export const REFRESH_EVENTS = "REFRESH_EVENTS"
export const EVENTS_REFRESHED = "EVENTS_REFRESHED"
export const REFRESH_EVENT_ANNOUNCEMENTS = "REFRESH_EVENT_ANNOUNCEMENTS"
export const EVENT_ANNOUNCEMENTS_REFRESHED = "EVENT_ANNOUNCEMENTS_REFRESHED"
export const GET_EVENT_DETAILS = "GET_EVENT_DETAILS"
export const GET_EVENT_DETAILS_SUCCESS = " GET_EVENT_DETAILS_SUCCESS"
export const SET_EVENT_DETAILS_STATUS = "SET_EVENT_DETAILS_STATUS"

export const GET_PENALTIES = "GET_PENALTIES_MANAGEMENT"
export const GET_PENALTIES_SUCCESS = "GET_PENALTIES_MANAGEMENT_SUCCESS"
export const GET_PENALTIES_ERROR = "GET_PENALTIES_MANAGEMENT_ERROR"

export const GET_EVENTS_LOCATIONS = "GET_EVENTS_LOCATIONS"
export const GET_EVENTS_LOCATIONS_SUCCESS = "GET_EVENTS_LOCATIONS_SUCCESS"

export const API_ERROR = "EVENTS_API_ERROR"
